<div  *ngIf="purchaseItemData"   class="mct-gap-11 mct-grid-gt-sm mct-cols-1-1-gt-sm">
  <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-4">
    <p-checkbox
      appendTo="body"
      binary="true"
      [ngModel]="purchaseItemData.Required"
      [disabled]="purchaseItemData.Required"
      inputId="revenueItemCheckbox"
    >
    </p-checkbox>
    <label for="revenueItemCheckbox">
      <span *ngIf="purchaseItemData.Required">*</span>{{ purchaseItemData.RevenueItemName }}
    </label>
  </div>
  <div class="mct-flex mct-justify-start mct-items-center mct-gap-4 mt-4">
    <input
      *ngIf="purchaseItemData.AllowCustomAmmount"
      type="number"
      class="form-control"
      [placeholder]="purchaseItemData.Price ?? ('form-builder.legos.purchase-item.custom-price-placeholder' | translate | ucfirst)"
    />
    <label *ngIf="!purchaseItemData.AllowCustomAmmount">{{ purchaseItemData.Price | currency }}</label>
  </div>
</div>
